import {createContext, useCallback, useContext, useRef} from 'react';

import {TileId} from './dashboardModel';

export interface TileImpressionObserver {
  /** Starts watching a tile's element; returns the function that stops. */
  observe: (element: Element, tileId: TileId) => () => void;
}

/** Set by the home dashboard; null everywhere else, so tiles reused elsewhere log nothing. */
export const HomeVisitContext = createContext<TileImpressionObserver | null>(null);

/** Callback ref that reports the element's visibility to the home visit tracker. */
export const useTileImpressionRef = (tileId: TileId | undefined) => {
  const observer = useContext(HomeVisitContext);
  const stopRef = useRef<() => void>();

  return useCallback(
    (element: Element | null) => {
      stopRef.current?.();
      stopRef.current =
        element && tileId && observer ? observer.observe(element, tileId) : undefined;
    },
    [observer, tileId]
  );
};
